import * as React from 'react';

const ReplyArrowSvg = ({size = 20, color = 'black'}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 27.361 27.361"
        xmlSpace="preserve"
        fill={color}
    >
        <path
            d="m0 12.022 9.328-9.328V6.84h9.326a8.706 8.706 0 0 1 8.707 8.706v9.12a8.703 8.703 0 0 0-8.707-8.704H9.328v5.389z"/>
    </svg>
);
export default ReplyArrowSvg;
